import React, { useState, useEffect, useCallback } from 'react';
import { Checkbox, Radio } from 'tea-component';

import { GLOBAL_NO_CHINA, GLOBAL, GLOBAL_LIST, HALF } from '../../contants'
import NoData from './NoSearchData';
import Item from './Item';
import { RegionsProps, ItemProps } from '../type';
import * as styles from './regions.module.less';
import { getLocaleText } from '@/pages/home/components/RegionSelect/locale'

const Regions = (props: RegionsProps) => {
  const {
    searchValue = '',
    title,
    renderList: renderListProps,
    globalSelect,
    regionSelectList = [],
    activeItem,
    globalMsg,
    globalDes,
    showChinese,
    disableNoChina,
    hiddenNoChina,
    globalMessageHidden,
    activeItemOnchange,
    regionSelectListOnChange,
    globalSelectOnChange,
  } = props;
  const [renderList, setRenderList] = useState({} as any);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const hasData = renderList?.regions?.length > 0;

  // 全体操作
  const operationAll = (isAllChecked: boolean) => {
    if (isAllChecked) {
      regionSelectListOnChange([], true);
    } else {
      const allRegions = renderList?.regions?.map((region: any) => region?.id);
      regionSelectListOnChange(allRegions);
    }
    setIsAllChecked(!isAllChecked);
  };

  const getNewRegions = useCallback(() => {
    const newRegions: any[] = renderListProps?.regions?.filter((region: any) => {
      let flag = region?.name?.toLowerCase()?.includes(searchValue) || region?.cnname?.includes(searchValue);

      // 查找子节点中包含搜索条件的项
      for (const i in region?.children) {
        const market = region?.children[i];
        if (market?.name?.toLowerCase()?.includes(searchValue) || market?.cnname?.includes(searchValue)) {
          flag = true;
          break;
        }
      }
      return flag;
    });
    return newRegions
  }, [searchValue, renderListProps])

  const render = (renderList: any) => {
    let globalList = renderList?.global ?? [];
    if (hiddenNoChina) {
      globalList = renderList?.global?.filter((item: any) => item.id !== GLOBAL_NO_CHINA) ?? []
    }
    return (
      <>
        {searchValue?.length <= 0 && (
          <div className={styles.group}>
            <div className={styles.title}>{getLocaleText('title_overall')}</div>
            <div className={styles.list}>
              <Radio.Group
                className={styles.tea}
                value={globalSelect}
                onChange={globalSelectOnChange as any}
              >
                {globalList?.map((item: ItemProps) => (
                  <Item
                    {...item}
                    key={item.id}
                    name={globalDes ? globalDes : item?.name}
                    radio={true}
                    showChinese={showChinese}
                    activeItem={activeItem}
                    disabled={disableNoChina && item?.id === GLOBAL_NO_CHINA}
                    globalMessageHidden={globalMessageHidden}
                    globalMsg={globalMsg}
                    activeItemOnchange={(item: any) =>
                      activeItemOnchange(item, GLOBAL)
                    }
                  />
                ))}
              </Radio.Group>
            </div>
          </div>
        )}

        <div
          className={styles.group}
          style={searchValue?.length > 0 && !hasData ? { height: '100%', boxSizing: 'border-box' } : {}}
        >
          <div className={styles.title}>
            <span>{title[0]}</span>
            {hasData && (
              <span
                className={styles['operation-btn']}
                onClick={() => operationAll(isAllChecked)}
              >
                {(isAllChecked && getLocaleText('clear_all') || getLocaleText('select_all'))}
              </span>
            )}
          </div>
          {
            <div
              className={styles.list}
              style={searchValue?.length > 0 && !hasData ? { flex: 1 } : {}}
            >
              {(hasData && (
                <Checkbox.Group
                  className={styles.tea}
                  value={regionSelectList as any}
                  onChange={(value: any[], context: any) => regionSelectListOnChange(value, false, context)}
                >
                  {renderList?.regions?.map((item: ItemProps) => (
                    <Item
                      {...item}
                      key={item.id}
                      showChinese={showChinese}
                      activeItem={activeItem}
                      activeItemOnchange={activeItemOnchange}
                    />
                  ))}
                </Checkbox.Group>
              )) || <NoData text={getLocaleText('no_data')} />}
            </div>
          }
        </div>
      </>
    );
  };

  useEffect(() => {
    const halfSelectLength = renderListProps?.regions?.filter(
      (region: any) => region?.selectStatus === HALF,
    );

    const flag =
      !GLOBAL_LIST.includes(regionSelectList[0]) &&
      (Boolean(regionSelectList?.length) || Boolean(halfSelectLength?.length));
    setIsAllChecked(flag);
  }, [JSON.stringify(regionSelectList), JSON.stringify(renderListProps)]);

  useEffect(() => {
    setRenderList({
      ...renderListProps,
      regions: getNewRegions()
    })
  }, [renderListProps])

  useEffect(() => {
    // 过滤出符合搜索条件的数据，并且匹配 children name
    const newRegions = getNewRegions()
    setRenderList({
      ...renderListProps,
      regions: newRegions,
    });
    activeItemOnchange(newRegions[0])
  }, [searchValue]);

  return <div className={styles['region-container']}>{render(renderList)}</div>;
};

export default Regions;
